/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/skip-forward-icon/skip-forward-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=skip-forward-icon.component.css.map */
